// types/dataCriteria.ts

/**
 * 기준 타입 열거형
 */
export enum CriteriaType {
  SINGLE_DEVICE = "SINGLE_DEVICE",
  DEVICE_TOTAL = "DEVICE_TOTAL",
  REGION_SINGLE = "REGION_SINGLE",
  REGION_TOTAL = "REGION_TOTAL",
  CITY_TOTAL = "CITY_TOTAL",
}

/**
 * 등급 열거형
 */
export enum Grade {
  GOOD = "GOOD",
  NORMAL = "NORMAL",
  BAD = "BAD",
  VERY_BAD = "VERY_BAD",
}

/**
 * 기준 타입 설명
 */
export const CriteriaTypeDescription: Record<CriteriaType, string> = {
  [CriteriaType.SINGLE_DEVICE]: "각 기기별 단일 측정물질 기준",
  [CriteriaType.DEVICE_TOTAL]: "각 기기별 종합 측정물질 기준",
  [CriteriaType.REGION_SINGLE]: "지역(읍/면/동) 평균 단일 측정물질 기준",
  [CriteriaType.REGION_TOTAL]: "지역(읍/면/동) 평균 종합 측정물질 기준",
  [CriteriaType.CITY_TOTAL]: "나주시 전체 평균 종합 측정물질 기준",
};

/**
 * 등급 한국어 이름
 */
export const GradeKoreanName: Record<Grade, string> = {
  [Grade.GOOD]: "좋음",
  [Grade.NORMAL]: "보통",
  [Grade.BAD]: "나쁨",
  [Grade.VERY_BAD]: "매우나쁨",
};

/**
 * 등급 색상 클래스
 */
export const GradeColorClass: Record<Grade, string> = {
  [Grade.GOOD]: "good",
  [Grade.NORMAL]: "normal",
  [Grade.BAD]: "bad",
  [Grade.VERY_BAD]: "very-bad",
};

/**
 * 데이터 기준 생성/수정 타입
 */
export interface DataCriteriaCreateType {
  criteriaType: CriteriaType;
  grade: Grade;
  h2sValue: number;
  nh3Value: number;
  ch4Value: number;
  comparisonType: "이하" | "이상";
}

/**
 * 데이터 기준 응답 타입
 */
export interface DataCriteriaResponseType {
  id: number;
  criteriaType: CriteriaType;
  criteriaTypeDescription: string;
  grade: Grade;
  gradeKoreanName: string;
  h2sValue: number;
  nh3Value: number;
  ch4Value: number;
  comparisonType: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

/**
 * 타입별 그룹 응답 타입
 */
export interface DataCriteriaGroupResponseType {
  criteriaType: CriteriaType;
  criteriaTypeDescription: string;
  grades: DataCriteriaResponseType[];
}

/**
 * 등급별 데이터 타입
 */
export interface GradeDataType {
  grade: Grade;
  h2sValue: number;
  nh3Value: number;
  ch4Value: number;
  comparisonType: "이하" | "이상";
}

/**
 * 일괄 업데이트 타입
 */
export interface DataCriteriaBulkUpdateType {
  criteriaType: CriteriaType;
  gradeData: GradeDataType[];
}
